module.exports = __webpack_public_path__ + "static/media/bagy10.776811ee.png";